function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FF7828",
  d: "M.028 7.918C.622 7.173 10.709-5.04 23 7.953c-12.67 13.606-23 0-23 0l.003-.004zm11.47-4.444c-2.544 0-4.607 2.018-4.607 4.51 0 1.869 1.164 3.473 2.821 4.156.513.232 1.077.363 1.67.363.16 0 .318-.012.474-.03 2.379-.178 4.252-2.118 4.252-4.49 0-2.49-2.064-4.509-4.61-4.509zM11.5 5.69c1.294 0 2.344 1.027 2.344 2.293 0 1.267-1.05 2.294-2.344 2.294-1.295 0-2.345-1.027-2.345-2.294 0-1.266 1.05-2.293 2.345-2.293z",
  transform: "translate(-837 -424) translate(350 152) translate(210 259) translate(277 14)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FF7828",
  strokeLinecap: "square",
  strokeWidth: 2,
  d: "M18.5 0.5L4.5 14.5",
  transform: "translate(-837 -424) translate(350 152) translate(210 259) translate(277 14)"
}))))));

function SvgEyeClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.167ce67b.svg";
export { ForwardRef as ReactComponent };